// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewPassword-module-container-DJlzU{display:flex;max-width:90%;width:100%;margin-block:0;margin-inline:auto;flex-direction:column;justify-content:center;padding-block:0;padding-inline:30px}@media(min-width: 960px){.NewPassword-module-container-DJlzU{max-width:940px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "NewPassword-module-container-DJlzU"
};
export default ___CSS_LOADER_EXPORT___;
